import classNames from 'classnames/bind';
import { Text } from 'design-system';
import PropTypes from 'prop-types';
import styles from './DisplayDefaultMetadata.module.css';

const cx = classNames.bind(styles);

const DisplayDefaultMetadata = ({ title, metadata }) => {
  const metadataArray = Object.entries(metadata);
  const firstKeyValuePair = metadataArray[0] || [];
  const firstKey = firstKeyValuePair[0];
  const firstValue = firstKeyValuePair[1];
  return (
    <div className={cx('default-metadata-container')}>
      {metadataArray.length === 1 ? (
        <div className={cx('row')}>
          <Text fontWeight="semibold">{firstKey}</Text>
          <span className={cx('value')}>{firstValue}</span>
        </div>
      ) : (
        <>
          <Text fontWeight="semibold" mb="xs">
            {title}
          </Text>
          {metadataArray.map(([key, value], index) => {
            return (
              <div key={index} className={cx('row')}>
                <Text>{key}</Text>
                <span className={cx('value')}>{value}</span>
              </div>
            );
          })}
        </>
      )}
    </div>
  );
};

DisplayDefaultMetadata.propTypes = {
  title: PropTypes.string.isRequired,
  metadata: PropTypes.object.isRequired,
};

export default DisplayDefaultMetadata;
